import styled from 'styled-components';
import IconArrow from '../../assets/images/icon-arrow.svg';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';

const NavBack = () => {
  const {t} = useTranslation();
  let navigate = useNavigate();

  return (
    <Container>
      <Button onClick={() => navigate(-1)}>
        <img src={IconArrow} alt="arrow" />
        <span>{t('dashboard.back')}</span>
      </Button>
    </Container>
  );
};

export default NavBack;

const Container = styled.div`
  width: 100%;
  max-width: 1100px;
  padding: 0 20px;
  margin: 24px auto;
`;

const Button = styled.button.attrs({type: 'button'})`
  border: none;
  display: inline-flex;
  align-items: center;
  font-weight: 700;
  font-size: 16px;
  cursor: pointer;
  padding: 4px 12px 4px 4px;
  border-radius: 15px;
  color: ${(p) => p.theme.colors.orange500};
  background-color: ${(p) => p.theme.colors.orange100};

  &:hover {
    box-shadow: 0 0 0 1px ${(p) => p.theme.colors.orange500};
  }

  img {
    transform: rotate(180deg);
    width: 40px;
  }
`;
